import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fields" }
const _hoisted_2 = { class: "c-field" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "status"
}, "配信設定", -1)
const _hoisted_4 = {
  class: "c-field__body",
  style: {"justify-content":"center"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "c-field has-submit has-mt" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "送信する", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "戻る", -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", null, _toDisplayString(_ctx.userShueishaOnline.isSendMailMagazine ? "受け取る" : "受け取らない"), 1)
      ])
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        type: "button",
        class: "ha-btn is-submit",
        disabled: _ctx.isDeterringRef,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.update, this)))
      }, _hoisted_9, 8, _hoisted_7),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push({ name: _ctx.prevRoute }))),
        class: _normalizeClass(["ha-btn ha-btn--outline", { 'is-disabled':_ctx.isDeterringRef }])
      }, _hoisted_11, 2)
    ])
  ]))
}